import { buildApiUrl, ADMIN_ENDPOINTS } from '@/project/configs/api.js'

export default {
  url(payload) {
    return buildApiUrl(ADMIN_ENDPOINTS.REWARD_MILESTONE_DELETE, { pathParams: { id: payload.id } })
  },
  method() {
    return 'DELETE'
  },

  format(payload) {
    return {
      operation: 'delete',
      id: payload?.id
    }
  },

  parse(raw = {}) {
    if (!raw?.success && raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        success: false,
        message: raw?.message || 'Erreur lors de la suppression du milestone',
      }
    }

    return {
      statusCode: 200,
      success: true,
      message: 'Milestone supprimé avec succès',
      data: raw?.data,
    }
  },
}
